import { LoaderCircle } from "lucide-react";
import type React from "react";

interface LoadingProps {
	message?: string;
}

export const Loading: React.FC<LoadingProps> = ({ message = "Loading..." }) => {
	return (
		<div className="flex flex-col items-center justify-center h-full">
			<LoaderCircle className="animate-spin text-gray-500" size={48} />
			<p className="mt-4 text-gray-700">{message}</p>
		</div>
	);
};
